// extracted by mini-css-extract-plugin
module.exports = {"required":"BobClientSelector_required__3bnQM","error":"BobClientSelector_error__16YU4","Required":"BobClientSelector_Required__By3ny"};